import { useEffect, useState, useRef } from "react";
import { Clock, Home, Users, ThumbsUp } from "lucide-react";
const STATS = [
  { icon: Clock, value: 20, suffix: " ans", label: "d'experience" },
  { icon: Home, value: 500, suffix: "+", label: "installations" },
  { icon: Users, value: 500, suffix: "+", label: "clients satisfaits" },
  { icon: ThumbsUp, value: 100, suffix: "%", label: "engagement qualite" },
];
function AnimatedNumber({ target, suffix, isVisible }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 1800;
    const step = Math.ceil(target / (duration / 30));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 30);
    return () => clearInterval(timer);
  }, [isVisible, target]);
  return (
    <span className="text-3xl md:text-4xl font-extrabold text-white stat-number-highlight">
      {count}{suffix}
    </span>
  );
}
function StatItem({ stat, visible, index }) {
  const Icon = stat.icon;
  return (
    <div className={`stat-item flex flex-col items-center text-center flex-shrink-0 scroll-reveal-scale stagger-${index + 1}`}>
      <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-3">
        <Icon className="w-6 h-6 text-white" />
      </div>
      <AnimatedNumber target={stat.value} suffix={stat.suffix} isVisible={visible} />
      <span className="text-sm text-white/80 mt-1 font-medium whitespace-nowrap">{stat.label}</span>
    </div>
  );
}
export default function StatsSection() {
  const ref = useRef(null);
  const scrollRef = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  // Auto-scroll on mobile
  useEffect(() => {
    const el = scrollRef.current;
    if (!el || !visible) return;
    const isMobile = window.innerWidth < 768;
    if (!isMobile) return;
    let scrollPos = 0;
    let direction = 1;
    const maxScroll = el.scrollWidth - el.clientWidth;
    const timer = setInterval(() => {
      scrollPos += direction * 1;
      if (scrollPos >= maxScroll) direction = -1;
      if (scrollPos <= 0) direction = 1;
      el.scrollLeft = scrollPos;
    }, 30);
    return () => clearInterval(timer);
  }, [visible]);
  return (
    <section
      ref={ref}
      data-testid="stats-section"
      className="py-12 md:py-16 stats-gradient"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        {/* Desktop: grid */}
        <div className="hidden md:grid grid-cols-4 gap-12">
          {STATS.map((stat, idx) => (
            <StatItem key={stat.label} stat={stat} visible={visible} index={idx} />
          ))}
        </div>
        {/* Mobile: auto-scrolling horizontal */}
        <div
          ref={scrollRef}
          className="md:hidden flex gap-10 overflow-x-auto scrollbar-hide px-4"
          style={{ scrollBehavior: "smooth", WebkitOverflowScrolling: "touch", msOverflowStyle: "none", scrollbarWidth: "none" }}
          data-testid="stats-scroll"
        >
          {STATS.map((stat, idx) => (
            <StatItem key={stat.label} stat={stat} visible={visible} index={idx} />
          ))}
          {STATS.map((stat, idx) => (
            <StatItem key={`dup-${stat.label}`} stat={stat} visible={visible} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
